import {ReactElement, useContext} from "react";
import {PropertyExecutiveSummary} from "./PropertyExecutiveSummary";
import {GuestAuthenticationContext} from "../../contexts/guest-auth-context/GuestAuthContext";
import {ChartOfAccountsProvider} from "../../contexts/chartofaccounts/ChartOfAccountsContext";

export function PropertyExecutiveSummaryGuestWrapper(): ReactElement {
    const authContext = useContext(GuestAuthenticationContext);
    return (
        authContext.user ?
        <ChartOfAccountsProvider isGuest={true}>
            <PropertyExecutiveSummary user={{...authContext.user, isGuest: true, isAdmin: false}} property={authContext.user.property}/>
        </ChartOfAccountsProvider>
        :
        <></>
    );
}